export const navbarData = [
	{
		name: "Программы",
		link: "#",
		icon: "note",
	},
	{
		name: "Ближайшие мероприятия",
		link: "/calendar",
		icon: "events",
	},
	{
		name: "Поиск врача",
		link: "/searchDoctor",
		icon: "search",
	},
	{
		name: "Полезные статьи",
		link: "https://dzen.ru/preventage",
		icon: "notification",
	},
	{
		name: "Ассоциация",
		link: "/association",
		icon: "logo",
	},
]